/** Which Artisan control the roast profile section offers for a work order. */
export type ArtisanProfileControl = 'unlink' | 'picker' | 'none';

/**
 * Picks between "this work order has a profile — offer Unlink" and "it has none — offer
 * the picker".
 *
 * The count is of *selectable* profiles: the work order form loads Artisan profiles with
 * status=unsynced (workOrderReferenceData.ts), because that is the list the picker draws
 * from. Syncing a profile flips is_synced to TRUE and drops it out of that list.
 *
 * So the count decides the picker and nothing else. Gating the Unlink button on it too is
 * what made the button vanish from a work order that had just been synced, in a company
 * whose only Artisan profile was the one now linked — and unlinking was the only way to
 * put that profile back in the list, so nothing could reopen the door (WO-029).
 */
export function resolveArtisanProfileControl(input: {
  linkedArtisanProfileId?: string | null;
  availableArtisanProfileCount: number;
}): ArtisanProfileControl {
  if (input.linkedArtisanProfileId) return 'unlink';
  return input.availableArtisanProfileCount > 0 ? 'picker' : 'none';
}
